import React from "react";

class PasswordInput extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.props.onChange(event.target.value)

    }

    render() {
        const isValid = this.props.isValid;
        const validationClass = isValid === true ? "is-valid" : isValid === false ? "is-invalid" : ""

        return(
            <>
                <label className={"visually-hidden"} htmlFor={`form-${this.props.name}`}>Password</label>
                <div className={"input-group has-validation"}>
                    <span className={"input-group-text"}>&bull;</span>
                    <input className={`form-control ${validationClass}`} type={"password"} name={this.props.name} placeholder={this.props.placeholder}
                           required={true} autoComplete={"password"} onChange={this.handleChange}
                    />
                    {/*{isValid === false &&*/}
                    {/*    <div className={"invalid-feedback"}>*/}
                    {/*        Error*/}
                    {/*    </div>*/}
                    {/*}*/}
                </div>
            </>
        );
    }
}


export default PasswordInput



/*

div("col-12 col-lg-4") {
            label("visually-hidden") {
                htmlFor = "form-$inputName"
                + "E-Mail-Address"
            }
            div("input-group has-validation") {
                span("input-group-text") { + "@" }
                input(InputType.email, C.INPUT_ENC_TYPE, InputFormMethod.post, inputName,
                    // TODO? own attributes
                    "form-control $validationClass ")
                {
                    id = "form-$inputName"
                    required = true
                    placeholder = "E-Mail"
                    value = inputString
                    autoComplete = true
                }
                if (isInvalid) {
                    div("invalid-feedback") {
                        + if (errorCode == CloudUserFormValidation.EmailCode.ALREADY_USED) "E-Mail already used" else "Generic error"
                    }
                }
            }
        }

 */